module.exports = __webpack_public_path__ + "img/admin.53c70eda.png";